export const initialState = {
  me: {
    id: null,
    role: null,
    image: null,
    empresa: {
      hide_questionario: null,
      owner_id: null,
    },
  },
  loading: false,
  logged: undefined,
  status: '1111',
  errorMessage: "",
  errors:[],
  token: null,
  blank:false
};
